import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';

import { ThemeProvider } from '@material-ui/core';
import { ToastContainer } from 'react-toastify';
import GlobalStyle from './styles/global';

import AppProvider from './hooks';
import Routes from './routes';
import theme from './styles/theme';

import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 3,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const App: React.FC = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <AppProvider>
          <Routes />
        </AppProvider>
        <GlobalStyle />
        <ToastContainer theme="colored" position="bottom-right" />
      </BrowserRouter>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
